import { Box, type BoxProps } from "@mui/material";

import { mergeSxProps } from "../../Mui";
import { type ProblematicMuiPackagingProps } from "../../Mui/types";

/**
 * @deprecated Use the ListItem component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
interface LiProps extends Omit<ProblematicMuiPackagingProps<BoxProps<"li">>, "sx" | "component"> {
  sx?: Omit<BoxProps["sx"], "display">;
}

/**
 * @deprecated Use the ListItem component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export function Li(props: LiProps) {
  const { sx, ...rest } = props;
  return <Box component="li" {...rest} sx={mergeSxProps(sx, { display: "list-item" })} />;
}
